'use client';

import { useEffect, useRef } from 'react';

export const useIntersectionObserver = (
  onChange: (isIntersecting: boolean) => void,
  {
    root = null,
    rootMargin = '0px',
    threshold = 0,
  }: {
    root?: HTMLElement | null;
    rootMargin?: string;
    threshold?: number | number[];
  } = {},
) => {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        onChange(entry.isIntersecting);
      },
      { root, rootMargin, threshold },
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [root, rootMargin, threshold, onChange]);

  return { ref };
};
